import React from 'react';
import {useFormik, FormikContext} from "formik";
import { useDispatch } from 'react-redux';
import {setPostAuthorization} from '../../store/authorization/thunk/setAuthorization';
import {useStyles, initialValues} from './helpers';

const Authorization = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const onSubmit = (store) => {
        dispatch(setPostAuthorization({
            login: store.login.toLowerCase(),
            password: store.password
        }))        
    }

    const formik = useFormik({onSubmit, initialValues});
    
    if (window.location.protocol.indexOf('https') === -1 && (window.location.origin !== 'http://localhost:3000' && window.location.origin !== 'http://localhost:3002')) {
        window.location.replace('https://' + window.location.host)
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
            <h1 style={{padding: 0, margin: 0, color: '#fff', fontFamily: 'Montserrat, sans-serif', marginBottom: 20}}>Вход</h1>
            <FormikContext.Provider value={formik}>
                <form onSubmit={formik.handleSubmit} style={{display: 'flex', flexDirection: 'column', border: '1px solid rgba(255,255,255,.3)', borderRadius: 4, padding: 20, width: '80%'}}>
                    
                    <label htmlFor="login" style={{display: 'flex', flexDirection: 'column', marginBottom: 12}}>
                        <span style={{padding: 0, margin: 0, color: '#fff', fontFamily: 'Montserrat, sans-serif', marginBottom: 12}}>Логин</span>
                        <input 
                            type="text" 
                            className={classes.inp} 
                            name="login" 
                            id="login"  
                            value={formik.values.login} 
                            onChange={(v) => formik.setFieldValue('login', v.target.value)}
                        />
                    </label>
                    <label htmlFor="password" style={{display: 'flex', flexDirection: 'column', marginBottom: 20}}>
                        <span style={{padding: 0, margin: 0, color: '#fff', fontFamily: 'Montserrat, sans-serif', marginBottom: 12}}>Пароль</span>
                        <input 
                            type="password" 
                            className={classes.inp} 
                            name="password" 
                            id="password" 
                            value={formik.values.password} 
                            onChange={(v) => formik.setFieldValue('password', v.target.value)}
                        />
                    </label>
                    <button className={classes.btn}>ВОЙТИ</button>
                </form>
            </FormikContext.Provider> 
        </div>
    )
}

export default Authorization;